<div class="col-12 row cases-by-scoreclass-container">
  <h4>Products By Score Class</h4>
  @if (chartData) {
    <div class="chart-container col-12">
      <highcharts-chart
        style="width: 100%; display: block; overflow: hidden"
        [Highcharts]="Highcharts"
        [options]="chartData"
      />
    </div>
  }
  <ngx-loading
    [show]="loading"
    [config]="{
      fullScreenBackdrop: false,
    }"
  />
</div>
